import request from '@/server/request';
import axios from 'axios';
import {API_JAVA, API_SYS} from '@/utils/base';

/**
 * 查询首页所有商品分类
 */
export async function getIndexCategoryList (params) {
  return request(API_JAVA + '/purchase/category/index/list', {
    method: 'GET',
    params: params
  });
}

/**
 * 查询首页友情链接
 */
export async function getIndexfriendlyLinks (params) {
  return request(API_JAVA + '/backstage/friendlyLinks/list', {
    method: 'GET',
    params: params
  });
}

/**
 * 商品详情-查询商品详情
 */
export async function getGoodsDetailInfo (id) {
  return request(API_JAVA + `/jgw/jgwProduct/${id}`, {
    method: 'GET',
  });
}

// 收藏
export async function postFavorites (params) {
  return request(API_JAVA + `/jgw/productCollection/add`, {
    method: 'POST',
    data: params
  });
}

// 取消收藏
export async function postDelFavorites (params) {
  return request(API_JAVA + `/jgw/productCollection/delete/` + params.productId, {
    method: 'POST',
    // data: params
  });
}

/**
 * 商品详情-查询商品详情
 */
export async function getStoreDetail (id) {
  return request(API_JAVA + `/backstage/shop/${id}`, {
    method: 'GET',
  });
}

/**
 * 商品详情-收货地址列表
 */
export async function getReceiveAddressList (params) {
  return request(API_JAVA + `/jgw/MemberReceiveAddress/list`, {
    method: 'GET',
    params: params,
  });
}

/**
 * 商品详情-添加收货地址
 */
export async function postReceiveAddressAdd (params) {
  return request(API_JAVA + `/jgw/MemberReceiveAddress/add`, {
    method: 'POST',
    data: params,
  });
}

/**
 * 商品详情-下单
 */
export async function postGoodsDetailAddOrder (params) {
  return request(API_JAVA + `/jgw/jgwOrder/add`, {
    method: 'POST',
    data: params
  });
}

/**
 * 个人中心-买家-我的订单-获取订单列表
 */
export async function getMyOrderList (params) {
  return request(API_JAVA + `/jgw/jgwOrder/buyerOrderList`, {
    method: 'GET',
    params: params,
  });
}

/**
 * 个人中心-买家-我的订单-更新订单
 */
export async function postMyOrderUpdate (params) {
  return request(API_JAVA + `/jgw/jgwOrder/update`, {
    method: 'POST',
    data: params,
  });
}

/**
 * 个人中心-买家-供应信息(求购信息)-获取信息列表（参数中的dataType，0：供应；1：求购）
 */
export async function getSupplyAndDemandList (params) {
  return request(API_JAVA + `/tmr/supplyAndDemand/list`, {
    method: 'GET',
    params: params,
  });
}

/**
 * 个人中心-买家-供应信息(求购信息)-删除信息
 */
export async function postSupplyAndDemandDelete (params) {
  return request(API_JAVA + `/tmr/supplyAndDemand/delete/${params.id}`, {
    method: 'POST',
  });
}

/**
 * 个人中心-买家-供应信息(求购信息)-更新信息
 */
export async function postSupplyAndDemandUpdate (params) {
  return request(API_JAVA + `/tmr/supplyAndDemand/update`, {
    method: 'POST',
    data: params,
  });
}

/**
 * 个人中心-买家-供应信息(求购信息)-批量提交、审核、驳回
 */
export async function postSupplyAndDemandBatch (params) {
  // auditStatus审核状态 0:待提交 1:审核中 2:已通过 3:已驳回
  return request(API_JAVA + `/tmr/supplyAndDemand/batch/${params.auditStatus}`, {
    method: 'POST',
    data: params.ids,
  });
}

/**
 * 个人中心-买家-经纪人信息-获取信息列表
 */
export async function getBrokerList (params) {
  return request(API_JAVA + `/tmr/broker/list`, {
    method: 'GET',
    params: params,
  });
}

/**
 * 个人中心-买家-经纪人信息-删除信息
 */
export async function postBrokerDelete (params) {
  return request(API_JAVA + `/tmr/broker/delete/${params.id}`, {
    method: 'POST',
  });
}

/**
 * 个人中心-买家-经纪人信息-更新信息
 */
export async function postBrokerUpdate (params) {
  return request(API_JAVA + `/tmr/broker/update`, {
    method: 'POST',
    data: params,
  });
}

/**
 * 个人中心-买家-经纪人信息-批量提交、审核、驳回
 */
export async function postBrokerBatch (params) {
  // auditStatus审核状态 0:待提交 1:审核中 2:已通过 3:已驳回
  return request(API_JAVA + `/tmr/broker/batch/${params.auditStatus}`, {
    method: 'POST',
    data: params.ids,
  });
}

/**
 * 个人中心-买家-获取下载模板
 */
export async function getDownloadExcelTemplate (params) {
  return axios({
    method: 'get',
    url: API_JAVA + '/common/downloadExcelTemplate',
    responseType: 'blob', //告诉服务器需要的响应格式
    params: params,
    headers: {
      // 配置请求头，若统一处理可省略
      Accept: 'application/octet-stream'
    }
  })
    .then(response => {
      let blob = new Blob([response.data], {
        type: 'application/vnd.ms-excel' // 将会被放入到 blob 中的数组内容的 MIME 类型,常用 ：application/vnd.ms-excel
      });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = params.fileName;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    });
}

/**
 * 个人中心-买家-导出错误文档
 */
export async function getDownloadErrorExcel (params) {
  return axios({
    method: 'get',
    url: API_JAVA + '/tmr/excel/exportExcel',
    responseType: 'blob', //告诉服务器需要的响应格式
    params: params,
    headers: {
      // 配置请求头，若统一处理可省略
      Accept: 'application/octet-stream'
    }
  })
    .then(response => {
      let blob = new Blob([response.data], {
        type: 'application/vnd.ms-excel' // 将会被放入到 blob 中的数组内容的 MIME 类型,常用 ：application/vnd.ms-excel
      });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = '错误文件.xlsx';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    });
}

// 最新开始

/**
 * 个人中心-买家-查询付款凭证
 */
export async function getJgwPaymentDetail (params) {
  return request(API_JAVA + `/jgw/Payment/${params.orderId}`, {
    method: 'GET',
    params: params,
  });
}

/**
 * 个人中心-买家-新增订单付款
 */
export async function getJgwPaymentAdd (params) {
  return request(API_JAVA + `/jgw/Payment/add`, {
    method: 'POST',
    data: params,
  });
}

/**
 * 个人中心-买家-新增订单评价
 */
export async function getJgwEvaluateAdd (params) {
  return request(API_JAVA + `/jgw/Evaluate/add`, {
    method: 'POST',
    data: params,
  });
}

/**
 * 个人中心-买家-查询订单评价明细
 */
export async function getJgwEvaluateDetail (params) {
  return request(API_JAVA + `/jgw/Evaluate/${params.id}`, {
    method: 'GET',
    data: params,
  });
}

/**
 * 个人中心-买家-新增订单-售后表
 */
export async function getJgwOrderAfterSalesAdd (params) {
  return request(API_JAVA + `/jgw/orderAfterSales/add`, {
    method: 'POST',
    data: params,
  });
}

/**
 * 个人中心-买家-查询订单评价明细
 */
export async function getJgwEvaluateBuyerDetail (params) {
  return request(API_JAVA + `/jgw/Evaluate/buyer/${params.id}`, {
    method: 'GET',
    data: params,
  });
}

/**
 * 个人中心-买家-根据条件查询支付信息列表
 */
export async function getJgwReceiptList (params) {
  return request(API_JAVA + `/jgw/Receipt/list`, {
    method: 'GET',
    params: params,
  });
}

/**
 * 个人中心-买家-我的求购订单
 */
export async function getJgwPurchaseMyList (params) {
  return request(API_JAVA + `/jgw/purchase/myList`, {
    method: 'GET',
    params: params,
  });
}

/**
 * 个人中心-买家-关闭求购订单
 */
export async function getJgwPurchaseCloseId (params) {
  return request(API_JAVA + `/jgw/purchase/close/${params.id}`, {
    method: 'GET',
    params: params,
  });
}

/**
 * 个人中心-买家-查询求购订单表明细
 */
export async function getJgwPurchaseDetail (params) {
  return request(API_JAVA + `/jgw/purchase/${params.id}`, {
    method: 'GET',
    params: params,
  });
}

/**
 * 个人中心-买家-售后管理
 */
export async function getOrderAfterSalesMyList (params) {
  return request(API_JAVA + `/jgw/orderAfterSales/myList`, {
    method: 'GET',
    params: params,
  });
}

/**
 * 个人中心-买家-售后表明细
 */
export async function getOrderAfterSalesDetail (params) {
  return request(API_JAVA + `/jgw/orderAfterSales/${params.id}`, {
    method: 'GET',
    params: params,
  });
}

/**
 * 个人中心-买家-根据合同id查询合同文件
 */
export async function getJgwOrderContract (params) {
  return request(API_JAVA + `/jgw/jgwOrderContract/${params.id}`, {
    method: 'GET',
    params: params,
  });
}

/**
 * 个人中心-买家-根据条件查询订单-发票申请表列表
 */
export async function getJgwOrderInvoiceRequestsList (params) {
  return request(API_JAVA + `/jgw/orderInvoiceRequests/list`, {
    method: 'GET',
    params: params,
  });
}

/**
 * 个人中心-买家-根据条件查询订单-发票申请表
 */
export async function getJgwOrderInvoiceRequestsAdd (params) {
  return request(API_JAVA + `/jgw/orderInvoiceRequests/add`, {
    method: 'POST',
    data: params,
  });
}

/**
 * 个人中心-买家-查询订单-发票申请表明细
 */
export async function getJgworderInvoiceRequestsDetail (params) {
  return request(API_JAVA + `/jgw/orderInvoiceRequests/${params.id}`, {
    method: 'GET',
    params: params,
  });
}

/**
 * 个人中心-买家-查询订单-根据条件查询商品-收藏列表
 */
export async function getJgwProductCollectionList (params) {
  return request(API_JAVA + `/jgw/productCollection/list`, {
    method: 'GET',
    params: params,
  });
}

/**
 * 个人中心-买家-删除商品-收藏
 */
export async function getJgwProductCollectionDelete (params) {
  return request(API_JAVA + `/jgw/productCollection/delete/${params.id}`, {
    method: 'POST',
    data: params,
  });
}

/**
 * 个人中心-买家-查询用户资产表明细
 */
export async function getJgwjgwUserFund (params) {
  return request(API_JAVA + `/jgw/jgwUserFund/detail`, {
    method: 'GET',
    params: params,
  });
}

/**
 * 个人中心-买家-根据条件查询留言列表
 */
export async function getJgwFeedbackMyFeedbacklist (params) {
  return request(API_JAVA + `/jgw/feedback/myFeedbacklist`, {
    method: 'POST',
    data: params,
  });
}

/**
 * 个人中心-买家-删除留言
 */
export async function getJgwFeedbackDeleteId (params) {
  return request(API_JAVA + `/jgw/feedback/delete/${params.id}`, {
    method: 'POST',
    data: params,
  });
}

/**
 * 个人中心-买家-根据条件查询系统消息列表
 */
export async function getSysMessageList (params) {
  return request(API_SYS + `/sys/message/list`, {
    method: 'GET',
    params: params,
  });
}

/**
 * 个人中心-买家-更新发货信息
 */
export async function getJgwSendOutGoodsUpdate (params) {
  return request(API_JAVA + `/jgw/SendOutGoods/update`, {
    method: 'POST',
    data: params,
  });
}

/**
 * 个人中心-商家买家-更新发货信息
 */
export async function getOrderorderFarmShippingInfoupdate (params) {
  return request(API_JAVA + `/order/orderFarmShippingInfo/update`, {
    method: 'POST',
    data: params,
  });
}

export async function shoppingCart (params) {
  return request(API_JAVA + `/jgw/jgwOrder/shoppingCart`, {
    method: 'POST',
    data: params,
  });
}

export async function shoppingCartDetail (params) {
  return request(API_JAVA + `/jgw/jgwOrder/shoppingCartInfos`, {
    method: 'GET',
  });
}

export async function shoppingCartSettlement (params) {
  return request(API_JAVA + `/jgw/jgwOrder/shoppingCartSettlement`, {
    method: 'POST',
    data: params
  });
}

export async function shoppingCartDel (params) {
  return request(API_JAVA + `/jgw/jgwOrder/delShoppingCart`, {
    method: 'POST',
    data: params
  });
}

export async function modifyShoppingCart (params) {
  return request(API_JAVA + `/jgw/jgwOrder/modifyShoppingCart`, {
    method: 'POST',
    data: params
  });
}

// 获取城市列表
export function getCityList () {
  return request(API_JAVA + '/citys/list', {
    method: 'GET'
  });
}

// 公司认证
export function addCompanyAuth (params) {
  return request(API_JAVA + '/companies/add', {
    method: 'POST',
    data: params
  });
}

// 获取公司列表
export function getAuthCompany (params) {
  return request(API_JAVA + '/companies/list', {
    method: 'GET',
    params
  });
}

// 获取企业认证状态
export function getAuthenticated () {
  return request(API_JAVA + '/companies/user/authenticated');
}

/**
 * 个人中心-买家-获取合同列表
 */
export async function getMyContractList (params) {
  return request(`${API_JAVA}/contract/list`, {
    method: 'GET',
    params: params
  })
}
/**
 * 个人中心-卖方相关信息
 */
export async function getSellerInfo (params) {
  return request(`${API_JAVA}/jgw/jgwOrder/sellerInfo`, {
    method: 'GET',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/PersonalCenter.js